import React, {Component} from "react"

import Loading from "@irati/ui/src/Loading"
import {H4} from "@irati/ui/src//Typography/Heading"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {User} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {IconButton} from "@irati/ui/src/Button"

import EditFailedUser from "../../../components/Users/EditFailedUser/EditFailedUser"
import {ValidationButton, Wrapper, MarginTop, H2FlexGrow} from "./styled"

interface Props extends InjectIntl {
  headers: string[],
  handleCreate: (user: User) => void,
  gotoSuccess: (length: number) => void,
  removeUser: (user: User, cb: () => void) => void,
  added: any[],
  notAdded: any[],
  back?: () => void
}

interface State {
  load: Promise<any>|null
}

class AddPeopleFailed extends Component<Props, State> {
  state = {
    load: null
  }

  removeUser = (user: User) => {
    const {added, notAdded, removeUser, gotoSuccess} = this.props
    removeUser(user, () => {
      if (notAdded.length === 0) {
        gotoSuccess(added.length)
      }
    })
  }

  submitFailedUsers = () => {
    const {notAdded, added, handleCreate, gotoSuccess} = this.props
    const adding = [...notAdded].map((user) => handleCreate(user))
    const load = Promise.all(adding).then(() => {
      this.setState({load: null})
      if (notAdded.length === 0) {
        gotoSuccess(added.length)
      }
    })
    this.setState({load})
  }

  render() {
    const {load} = this.state
    const {notAdded, added, headers, formatMessage, back} = this.props
    const notAddedLength = notAdded.length
    const addedLength = added.length

    return (
      <Wrapper>
        <Loading load={load}>
          <Flex alignItems="center" margin="0 0 30px 0">
            {back && <IconButton onClick={back} icon="backArrow" />}
            <H2FlexGrow className="flush--top push--bottom center">
              <FormattedMessage id="admin.containers.addPeopleFailed.headingTwo.notAdded.text" values={{notAddedLength}} />
            </H2FlexGrow>
          </Flex>
          {added.length >= 1 &&
          <H4 className="center flush--top push--bottom">
            <FormattedMessage id="admin.containers.addPeopleFailed.headingTwo.added.text" values={{addedLength}} />
          </H4>}
          <MarginTop>
            {notAdded.map((user) => (
              <EditFailedUser
                key={user.email}
                user={user}
                removeUser={this.removeUser}
                headers={headers} />
            ))}
          </MarginTop>
        </Loading>
        <ValidationButton
          primary
          large
          load={load}
          loading={formatMessage({id: "admin.containers.addPeopleFailed.validationButton.loading"}, {notAddedLength})}
          onClick={this.submitFailedUsers}>
          <FormattedMessage id="admin.containers.addPeopleFailed.validationButton.text" />
        </ValidationButton>
      </Wrapper>
    )
  }
}

export default injectIntl(AddPeopleFailed)
